module.exports = __webpack_public_path__ + "static/media/separation.57bed466.svg";